import { IEventrTransport } from "@eventr/common";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";
import { routes } from "routing";
import { getCategoryProperties } from "utils";
import { useScreenTypeContext } from "v2/state/screenTypeProvider";
import { isSameDay } from "./card-utils";
import { ObjectProvider } from "./providers/objectProvider";
import { BaseCard } from "./subComponents/baseCard";
import { TransportHeader } from "./transportComponents/transportHeader";
import { TransportInfo } from "./transportComponents/transportInfo";
import { TransportTimes } from "./transportComponents/transportTimes";

interface TransportCardProps {
  id?: string;
  data: IEventrTransport;
  past?: boolean;
  border?: boolean;
  date?: string | undefined;
}

export default function TransportCard({ id, data, past = false, date }: TransportCardProps) {
  const { screenType } = useScreenTypeContext();
  const { pushPath } = useGlobalRouter();

  const startOrEnd = data?.startOrEnd;
  const handleClick = () => {
    if (data._id && screenType !== "edit") {
      pushPath(routes.item.transport.build({ itemId: data._id }), { state: { screenType, date, startOrEnd } });
    }
  };

  return (
    <ObjectProvider past={past} _id={data._id ?? "transport_card"} sectionID="5">
      <BaseCard id={id} past={past} onClick={handleClick}>
        <TransportHeader
          category={getCategoryProperties(data?.categories?.[0])}
          transport_alias={data.transport_alias}
          label={data.label}
          labelTime={data.labelTime}
          checkInTime={data.check_in}
          pick_up={data.pick_up}
          drop_off={data.drop_off}
          transport_type={data.transport_type}
          visibility={data.visibility}
          date={date}
        />
        {(data.label || (date && (isSameDay(date, data.pick_up) || isSameDay(date, data.drop_off)))) && (
          <TransportTimes
            pick_up={data.pick_up}
            drop_off={data.drop_off}
            pick_up_location={data.pick_up_location}
            drop_off_location={data.drop_off_location}
            pick_up_stop={data["pick-up_stop"]}
            drop_off_stop={data["drop-off_stop"]}
          />
        )}
        <TransportInfo
          booking_ref={data.booking_ref}
          pick_up={data.pick_up}
          pick_up_location={data.pick_up_location}
          pick_up_address={data.pick_up_address}
          drop_off={data.drop_off}
          drop_off_address={data.drop_off_address}
          drop_off_location={data.drop_off_location}
          documents={data.documents}
          additional_info={data.additional_information}
          passengers_list={data.passengers_list}
          chatNames={[data.transport_alias]}
        />
      </BaseCard>
    </ObjectProvider>
  );
}
